import React, { useContext, useEffect, useState } from "react";
import {
  Layout,
  Row,
  Popover,
  Button,
  Col,
  Menu,
  theme,
  MenuProps,
  Divider,
  ConfigProvider,
  Drawer,
  Tooltip,
  Typography,
  Result,
  message,
} from "antd";
// import companylogo1 from "../../images/LogoIcon.svg";
import {
  MenuOutlined,
  PlusOutlined,
  ReadOutlined,
  UserOutlined,
  WifiOutlined,
} from "@ant-design/icons";
import { Link, matchPath, useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { useUser } from "../../Context/UserContext";
import companylogo from "../../images/companyLogo.svg";
import companylogo1 from "../../images/companyLogoIcon.svg";

import "./Dashboardlayout.css";
import PageRoute from "./Routing/PageRoute";
import ClientDataProvider from "../Context/ClientContext";
import { CgShoppingCart } from "react-icons/cg";
import { TfiBag } from "react-icons/tfi";
import { useTheme } from "../Context/ThemeContext";
import AddItems from "../Pages/Items/AddItems";
import { ContentUser } from "../../Common/Admin/AdminComponent";
import "../Common/Dashboardlayout.css";
import allclients from "../../images/allclient.png";
import saleslogo from "../../images/saleslogo.png";
import purchaselogo from "../../images/purchaselogo.png";
import journals from "../../images/journals.png";
import masters from "../../images/masters.png";
import dashbrd from "../../images/dashbrd.svg";
import bankImg from "../../images/bankImg.svg";
import AssetImg from "../../images/AssetImg.svg";

import AddLedger from "../Pages/Master/Ledger/AddLedger";
import AddSalesInvoice from "../Pages/SalesAndPurchase/InvoiceAndPurchaseBill/Add/AddSalesInvoiceAndPurchaseBill";
import AdjustBankBalanceModel from "../Pages/Banking/ImportTransactions/AdjustBankBalanceModel";
import FloatButtons from "./FloatButtons";
import AddGroup from "../Pages/Master/Group/AddGroup";
import { useHotkeys } from "react-hotkeys-hook";
import Avatar from "antd/es/avatar/avatar";
import {
  MasterName,
  SearchLedgerByGroupsTypes,
} from "../Services/LedgerService";
import {
  AllClientIcon,
  AssetIcon,
  CashndBankIcon,
  DashBoardIcon,
  DraftIcon,
  ExpndIncIcon,
  ItemIcon,
  JournalIcon,
  MasterIcon,
  MenuIcon,
  PartiesIcon,
  PurchaseIcon,
  RegIcon,
  ReportIcon,
  SalesIcon,
  SettingIcon,
} from "./Icon";
import adminContext from "../../Context/AdminContext";
import { IClientRoleList } from "../../Types";
import ClientRoleServices from "../Services/ClientRoleServices";
import CustomerRoleServices from "../Services/CustomerRoleServices";
import {
  IRole,
  ITypeIIsClientSpecificRoleDataType,
  useRole,
} from "../../Context/RoleContext";
import { FullPageSpinner } from "./FullPageSpinner";
import {
  findUserOnlyOnePremission,
  findUserPremission,
  premissionLedgerAndGroup,
} from "../Pages/Users/Roles/UserSecurityFind";
import NavLinkPathIsCompanyRole from "../Pages/Clients/NavLinkPathIsCompanyRole";
import SettingService, { SettingsSections } from "../Services/SettingService";
import { clientSpecifxRoleVoucherName } from "../Pages/Users/Roles/AddClientRoles";
import { IPermissionActionType } from "../Pages/Users/Roles/UserPermissionCommonData";
import InventoryPageRoute from "./InventoryPageRoute";
import UnitModel from "../Pages/ItemUnit/AddItemUnit";
import { HotkeyProvider, useHotkey } from "../Context/HotKeyContext";

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

type MenuItem = Required<MenuProps>["items"][number];

const AccountsMainLayout: React.FC = () => {
  const { showKeys } = useHotkey();
  const navigate = useNavigate();
  const {
    isAuthenticated,
    getUserId,
    getUser,
    clientSpecificRole,
    clientRoleList,
  } = useUser();
  const { setCurrentRole, getRole } = useRole();
  const themeData: any = useTheme();
  const [openLogDrawer, setOpenLogDrawer] = React.useState(false);
  const [collapsed, setCollapsed] = React.useState<boolean>(false);
  const { userData, trigger, getUserdata, loadSkeleton } =
    useContext(adminContext);
  const [width, setWidth] = React.useState<any>(window.innerWidth);
  const [openSiderDrawer, setOpenSiderDrawer] = React.useState(false);
  const [openQuickAdd, setOpenQuickAdd] = React.useState(false);
  const [quickAddProps, setQuickAddProps] = React.useState<{
    type: string;
    open: boolean;
    iType?: any;
  }>({
    type: "",
    open: false,
    iType: "",
  });
  const [unitTrigger, setUnitTrigger] = React.useState<boolean>(false);
  const [logData, setLogData] = React.useState<any>([]);
  const [loading, setLoading] = React.useState<boolean>(true);
  const [allRoleData, setAllRoleData] = React.useState<any>();
  const location = useLocation();

  const clientId =
    matchPath(`/billing/clients/:clientId/*`, location.pathname)?.params
      ?.clientId ||
    matchPath(`/inventory/clients/:clientId/*`, location.pathname)?.params
      ?.clientId ||
    matchPath(`/vendor/clients/:clientId/*`, location.pathname)?.params
      ?.clientId;

  React.useEffect(() => {
    if (clientSpecificRole()) {
      const getLocalClientRole = getRole()?.find(
        (x: any) => x.clientIdList[0] === clientId
      );
      // console.log("local data", getLocalClientRole);
      if (!getLocalClientRole) {
        const clientRole: IClientRoleList = clientRoleList()?.find(
          (x: IClientRoleList) => x.id[0] === clientId
        );
        // console.log("clientRole", clientRole);

        if (clientRole?.isClientRole) {
          try {
            setLoading(true);
            const getClientRoleApi = async () => {
              const [clientRoleData, allVoucherName] = await Promise.all([
                ClientRoleServices.getRoleById(clientId!, clientRole.roleId),
                SettingService.getVoucherNameListSetting(clientId!),
              ]);

              // const getRole: IRole[] = Utils.getLocal("RoleList");

              const contextSet: IRole[] = [
                {
                  clientIdList: [clientRoleData.result?.companyId],
                  roleId: clientRoleData.result?.id,
                  roleName: clientRoleData.result?.name,
                  description: clientRoleData.result?.description,
                  accessSettings: clientRoleData.result?.accessSettings,
                  isClientSpecificRoleVouchersData:
                    clientSpecifxRoleVoucherName(allVoucherName.result),
                },
              ];
              setCurrentRole(contextSet);

              // console.log(
              //   "allVoucherName",
              //   ClientVoucherTabs1(allVoucherName.result)
              // );
              // Utils.setLocal("RoleList", contextSet);

              console.log("local data clientSpecificRole true", getRole());
              if (getRole()) {
                // const data = getRole();
                // setAllRoleData(data);
                navigate(
                  NavLinkPathIsCompanyRole(clientId!, clientSpecificRole())
                );
                setLoading(false);
              }
            };
            getClientRoleApi();
          } catch (ex) {
            console.error("error", ex);
          } finally {
            // setLoading(false);
          }
        } else {
          try {
            setLoading(true);

            const getCompanyRoleApi = async () => {
              const customerRoleData = await CustomerRoleServices.getRoleById(
                clientId!,
                clientRole.roleId
              );

              const contextSet: IRole[] = [
                {
                  clientIdList: [clientId],
                  roleId: customerRoleData.result?.id,
                  roleName: customerRoleData.result?.name,
                  description: customerRoleData.result?.description,
                  accessSettings: customerRoleData.result?.accessSettings,
                },
              ];

              // console.log(
              //   "allVoucherName",
              //   ClientVoucherTabs1(allVoucherName.result)
              // );

              setCurrentRole(contextSet);

              if (getRole()) {
                // const data = getRole();
                // const x = NavLinkPathIsCompanyRole(
                //   clientId!,
                //   clientSpecificRole()
                // );
                // console.log("localData nav link", x);
                navigate(
                  NavLinkPathIsCompanyRole(clientId!, clientSpecificRole())
                );

                // setAllRoleData(data);
                setLoading(false);
                // const route = NavLinkPathIsCompanyRole(
                //   clientId!,
                //   clientSpecificRole()
                // );
              }
              // console.log("getCompanyRoleApi true", customerRoleData);
            };
            getCompanyRoleApi();
          } catch (ex) {
            console.error("error", ex);
          } finally {
            // setLoading(false);
          }
        }
      } else {
        // setAllRoleData([{}]);
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clientId]);

  // const productModule: Product_Module = location.state?.productModule;

  console.log("location.state?.productModule", location.state?.productModule);

  console.log("path", location.pathname);

  // const { productModule }: Product_Module = location.state || {};

  // const [clientId, setClientId] = useState(clientId1);
  // useEffect(() => {
  //   setClientId(clientId);
  // }, [clientId1]);
  const [locationUrl, setLocationUrl] = React.useState<string>("");
  const { defaultAlgorithm, darkAlgorithm } = theme;
  // useHotkeys(
  //   "ctrl+c+l",
  //   (event) => {
  //     event.preventDefault();
  //     setQuickAddProps({
  //       type: "AddLedger",
  //       open: true,
  //     });
  //   },
  //   { preventDefault: true }
  // );
  const notify = (action: any) => {
    message.info(`Action triggered: ${action}`);
  };
  const [isConnected, setIsConnected] = React.useState(true);
  // console.log("themeData----------", themeData?.themeColor, themeData );
  useEffect(() => {
    getUserdata();
  }, [trigger]);

  React.useEffect(() => {
    const handleNetworkChange = () => {
      setIsConnected(navigator.onLine);
    };

    window.addEventListener("online", handleNetworkChange);
    window.addEventListener("offline", handleNetworkChange);

    return () => {
      window.removeEventListener("online", handleNetworkChange);
      window.removeEventListener("offline", handleNetworkChange);
    };
  }, []);

  React.useEffect(() => {
    if (!isAuthenticated()) navigate("/login");

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [navigate]);

  //----- Menu Color in -----
  React.useEffect(() => {
    let splittedpath = location.pathname.split("/");
    // console.log("Splitted", splittedpath);
    setLocationUrl(
      `/${splittedpath[1]}/${splittedpath[2]}/${splittedpath[3]}/${
        splittedpath[4] === "income"
          ? "expenses"
          : splittedpath[4] === "incomeLedger"
          ? "expenses"
          : splittedpath[4] === "incomeGroup"
          ? "expenses"
          : splittedpath[4] === "expensesLedger"
          ? "expenses"
          : splittedpath[4] === "expensesGroup"
          ? "expenses"
          : splittedpath[4] === "costCentres"
          ? "expenses"
          : splittedpath[4]
      }`
    );
  }, [location]);

  const { mainCategory, clientid, section } = React.useMemo(() => {
    const splittedPath = location.pathname.split("/");
    return {
      mainCategory: splittedPath[1],
      clientid: splittedPath[3],
      section: splittedPath[4],
    };
  }, [location.pathname]);

  React.useEffect(() => {
    // console.log(width);
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [width]);

  //#region Commented code  ------------- Short Cut Key (Ex.= alt+p+o ) -------------

  // React.useEffect(() => {
  //   const handleKeyDown = (event: any) => {
  //     if (event.altKey && event.key.toLowerCase() === "s" && !event.shiftKey) {
  //       document.addEventListener("keydown", handleNextKeyDownSales);
  //     } else if (
  //       event.altKey &&
  //       event.key.toLowerCase() === "p" &&
  //       !event.shiftKey
  //     ) {
  //       document.addEventListener("keydown", handleNextKeyDownPurchase);
  //     } else if (
  //       event.altKey &&
  //       event.key.toLowerCase() === "j" &&
  //       !event.shiftKey
  //     ) {
  //       navigate(`/billing/clients/${clientId}/journals/add`);
  //     } else if (
  //       event.altKey &&
  //       event.key.toLowerCase() === "l" &&
  //       !event.shiftKey
  //     ) {
  //       navigate(`/billing/clients/${clientId}/ledger`);
  //     } else if (
  //       event.altKey &&
  //       event.key.toLowerCase() === "t" &&
  //       !event.shiftKey
  //     ) {
  //       navigate(`/billing/clients/${clientId}/trialbalance`);
  //     } else if (
  //       event.altKey &&
  //       event.key.toLowerCase() === "b" &&
  //       !event.shiftKey
  //     ) {
  //       navigate(`/billing/clients/${clientId}/BalanceSheet`);
  //     } else if (
  //       event.altKey &&
  //       event.key.toLowerCase() === "c" &&
  //       !event.shiftKey
  //     ) {
  //       navigate(`/billing/clients/${clientId}/chartOfAccounts`);
  //     }
  //     // } else if (
  //     //   event.shiftKey &&
  //     //   event.key.toLowerCase() === "s" &&
  //     //   !event.altKey
  //     // ) {
  //     //   navigate(`/billing/clients/${clientId}/settings`);
  //     // }
  //   };

  //   const handleNextKeyDownSales = (event: any) => {
  //     if (event.key.toLowerCase() === "i") {
  //       navigate(`/billing/clients/${clientId}/sales/addInvoice`);
  //     } else if (event.key.toLowerCase() === "c") {
  //       navigate(`/billing/clients/${clientId}/sales/addCreditNote`);
  //     } else if (event.key.toLowerCase() === "e") {
  //       navigate(`/billing/clients/${clientId}/sales/addEstimates`);
  //     } else if (event.key.toLowerCase() === "r") {
  //       navigate(`/billing/clients/${clientId}/sales/addReceipts`);
  //     }
  //     document.removeEventListener("keydown", handleNextKeyDownSales);
  //   };

  //   const handleNextKeyDownPurchase = (event: any) => {
  //     if (event.key.toLowerCase() === "i") {
  //       navigate(`/billing/clients/${clientId}/purchase/invoice`);
  //     } else if (event.key.toLowerCase() === "c") {
  //       navigate(`/billing/clients/${clientId}/purchase/creditnote`);
  //     } else if (event.key.toLowerCase() === "o") {
  //       navigate(`/billing/clients/${clientId}/purchase/order`);
  //     } else if (event.key.toLowerCase() === "p") {
  //       navigate(`/billing/clients/${clientId}/purchase/payment`);
  //     } else if (event.key.toLowerCase() === "l") {
  //       navigate(`/billing/clients/${clientId}/profitAndLoss`);
  //     }
  //     document.removeEventListener("keydown", handleNextKeyDownPurchase);
  //   };

  //   document.addEventListener("keydown", handleKeyDown);

  //   return () => {
  //     document.removeEventListener("keydown", handleKeyDown);
  //     document.removeEventListener("keydown", handleNextKeyDownPurchase);
  //   };
  // }, []);
  //#endregion

  //#region -------------  Shortcut Keys -------------
  useEffect(() => {
    const handleKeyDown = (event: any) => {
      if (event.ctrlKey && event.shiftKey) {
        switch (event.key.toLowerCase()) {
          // case "f2":
          //   event.preventDefault();
          //   console.log("Ctrl+Shift+F2 pressed");
          //   // notify("Locking Period");
          //   break;
          case "d":
            if (
              findUserPremission(
                ["Dashboard.View"],
                clientSpecificRole(),
                clientId
                // allRoleData
              )
            ) {
              event.preventDefault();
              navigate(`/billing/clients/${clientId}/dashboard`);
            }
            break;
          case "l":
            if (
              premissionLedgerAndGroup(
                clientId!,
                SearchLedgerByGroupsTypes.All,
                IPermissionActionType.Add,
                MasterName.Ledger
              )
            ) {
              event.preventDefault();
              navigate(`/billing/clients/${clientId}/master/ledger`);
              setQuickAddProps({
                type: "AddLedger",
                open: true,
                iType: SearchLedgerByGroupsTypes.All,
              });
            }
            break;
          case "g":
            if (
              premissionLedgerAndGroup(
                clientId!,
                SearchLedgerByGroupsTypes.All,
                IPermissionActionType.Add,
                MasterName.Group
              )
            ) {
              event.preventDefault();
              navigate(`/billing/clients/${clientId}/master/group`);
              setQuickAddProps({
                type: "AddGroup",
                open: true,
                iType: SearchLedgerByGroupsTypes.All,
              });
            }
            break;
          case "i":
            if (
              findUserPremission(
                ["Master.Item.Add"],
                clientSpecificRole(),
                clientId
              )
            ) {
              event.preventDefault();
              navigate(`/billing/clients/${clientId}/item/items`);
              setQuickAddProps({
                type: "AddItems",
                open: true,
              });
            }
            // notify("Item");
            break;
          case "u":
            if (
              findUserPremission(
                ["Master.Item.Unit.Add"],
                clientSpecificRole(),
                clientId
              )
            ) {
              event.preventDefault();
              navigate(`/billing/clients/${clientId}/item/units`);
              setQuickAddProps({
                type: "AddUnits",
                open: true,
              });
            }
            break;
          // case "r":
          //   event.preventDefault();
          //   navigate(`/billing/clients/${clientId}/sales/addReceipt`);
          //   setQuickAddProps({
          //     type: "",
          //     open: false,
          //   });
          //   // notify("Receipt");
          //   break;
          case "q":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/sales/addEstimate`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Sales Quotation");
            break;
          // case "o":
          //   event.preventDefault();
          //   navigate(`/billing/clients/${clientId}/sales/addOrder`);
          //   setQuickAddProps({
          //     type: "",
          //     open: false,
          //   });
          //   // notify("Sales Order");
          //   break;
          // case "d":
          //   event.preventDefault();
          //   navigate(`/billing/clients/${clientId}/sales/addOrder`);
          //   setQuickAddProps({
          //     type: "",
          //     open: false,
          //   });
          //   // notify("Delivery Challan");
          //   break;
          // case "p":
          //   event.preventDefault();
          //   navigate(`/billing/clients/${clientId}/purchase/addPaymentOut`);
          //   setQuickAddProps({
          //     type: "",
          //     open: false,
          //   });
          //   // notify("Payment");
          //   break;
          // case "s":
          //   event.preventDefault();
          //   navigate(`/billing/clients/${clientId}/sales/addInvoice`);
          //   setQuickAddProps({
          //     type: "",
          //     open: false,
          //   });
          //   // notify("Sales Invoice");
          //   break;

          case "f1":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/party/parties`);
            setQuickAddProps({
              type: "AddParty",
              open: false,
              iType: SearchLedgerByGroupsTypes.PartiesOnly,
            });
            // notify("Settings");
            break;
          case "f11":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/reports`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Settings");
            break;
          case "f12":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/settings/companyInfo`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Settings");
            break;
        }
      } else if (event.shiftKey) {
        // event.preventDefault(); // Prevent default action for all key events
        switch (event.key.toLowerCase()) {
          case "f3":
            event.preventDefault();
            setQuickAddProps({
              type: "",
              open: false,
            });
            navigate(`/billing/clients/${clientId}/expenses/addExpenses`);
            // notify("Sales Return");
            break;
          case "f4":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/banking/bankAccounts`);
            setQuickAddProps({
              type: "AdjustBankBalanceModel",
              open: true,
            });
            // notify("Sales Return");
            break;
          case "f5":
            event.preventDefault();
            setQuickAddProps({
              type: "",
              open: false,
            });
            navigate(`/billing/clients/${clientId}/sales/addInvoice`);
            // notify("Sales Return");
            break;
          case "f6":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/sales/addCreditNote`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Sales Return");
            break;
          case "f7":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/sales/addReceipt`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Receipt");
            break;
          case "f8":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/sales/addOrder`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Sales Order");
            break;
          case "f9":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/purchase/addPurchaseBill`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Purchase Bill");
            break;
          case "f10":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/purchase/addDebitNote`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Purchase Return");
            break;
          case "f11":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/purchase/addPaymentOut`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Payment");
            break;
          case "f12":
            event.preventDefault();
            navigate(`/billing/clients/${clientId}/purchase/addOrder`);
            setQuickAddProps({
              type: "",
              open: false,
            });
            // notify("Purchase Order");
            break;
        }
      }
    };

    // Add event listener when component mounts
    document.addEventListener("keydown", handleKeyDown);

    // Cleanup event listener on component unmount
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [clientId]);
  //#endregion

  const buttonDark = (currentUrl: any) => {
    // console.log("hello----------------button Dark");
    return location.pathname === currentUrl ? "link" : "text";
  };

  const forActndInActive = (currentUrl: any) => {
    return locationUrl === currentUrl ? true : false;
  };

  const showLogDrawer = () => {
    setOpenLogDrawer(true);
  };
  const CloseLogDrawer = () => {
    setOpenLogDrawer(false);
  };
  let loginUser = { ...getUser() };

  console.log("getUsergetUsergetUser", loginUser);

  //#region --------------- QuickAdd Button not used ---------------
  const QuickAdd = (
    <Row>
      <Col sm={8} xs={11}>
        <p style={{ marginBottom: "6px" }}>
          <CgShoppingCart
            fontSize={15}
            style={{ padding: "0px 12px 0px 7px" }}
          />
          Sales
        </p>
        <p>
          <Link
            to={`/billing/clients/${clientId}/sales/addInvoice`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="(Alt+S+I)" placement="left">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/sales/addInvoice`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/sales/invoices`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/sales/invoices`)}
            >
              Invoice
            </Button>
          </Link>
        </p>
        <p>
          <Link
            to={`/billing/clients/${clientId}/sales/addCreditNote`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Add Credit Note (Alt+S+C)" placement="left">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/sales/addCreditNote`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/sales/creditNotes`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(
                `/billing/clients/${clientId}/sales/creditNotes`
              )}
            >
              Credit Notes
            </Button>
          </Link>
        </p>
        <p>
          <Link
            to={`/billing/clients/${clientId}/sales/addEstimates`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Add Estimates(Alt+S+E)" placement="left">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/sales/addEstimates`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/sales/estimates`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/sales/estimates`)}
            >
              Estimates
            </Button>
          </Link>
        </p>
        <p>
          <Link
            to={`/billing/clients/${clientId}/sales/addReceipts`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Add Receipt(Alt+S+R)" placement="left">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/sales/addReceipts`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/sales/receipts`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/sales/receipts`)}
            >
              Receipts
            </Button>
          </Link>
        </p>
        <p>
          <Tooltip title="Add Customer" placement="left">
            <Button
              type="text"
              className={"ca-quickadd-btn"}
              onClick={() => {
                setQuickAddProps({ type: "addCustomer", open: true });
                setOpenQuickAdd(false);
              }}
            >
              <PlusOutlined />
            </Button>
          </Tooltip>
          <Link
            to={`/billing/clients/${clientId}/sales/customers`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/sales/customers`)}
            >
              Customers
            </Button>
          </Link>
        </p>
        <p>
          <Tooltip title="Add Item" placement="left">
            <Button
              type="text"
              className={"ca-quickadd-btn"}
              onClick={() => {
                setQuickAddProps({ type: "addItem", open: true });
                setOpenQuickAdd(false);
              }}
            >
              <PlusOutlined />
            </Button>
          </Tooltip>

          <Link
            to={`/billing/clients/${clientId}/sales/items`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/sales/items`)}
            >
              Items
            </Button>
          </Link>
        </p>
      </Col>

      <Col sm={8} xs={11}>
        <p style={{ marginBottom: "6px" }}>
          <TfiBag style={{ padding: "0px 8px 0px 7px" }} /> Purchase
        </p>

        <p>
          <Link
            to={`/billing/clients/${clientId}/purchase/invoice`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="(Alt+P+I)" placement="topLeft">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/purchase/invoice`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>

          <Link
            to={`/billing/clients/${clientId}/purchase/addPurchaseBill`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(
                `/billing/clients/${clientId}/purchase/addPurchaseBill`
              )}
            >
              Invoice
            </Button>
          </Link>
        </p>

        <p>
          <Link
            to={`/billing/clients/${clientId}/purchase/creditnote`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Add Credit Note (Alt+P+C)" placement="topLeft">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/purchase/creditnote`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/purchase/creditNotes`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(
                `/billing/clients/${clientId}/purchase/creditNotes`
              )}
            >
              Credit Notes
            </Button>
          </Link>
        </p>

        <p>
          <Link
            to={`/billing/clients/${clientId}/purchase/order`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Add Order (Alt+P+O)" placement="topLeft">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(`/billing/clients/${clientId}/purchase/order`)}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/purchase/purchaseOrders`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(
                `/billing/clients/${clientId}/purchase/purchaseOrders`
              )}
            >
              Order
            </Button>
          </Link>
        </p>

        <p>
          <Link
            to={`/billing/clients/${clientId}/purchase/payment`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Add Payment (Alt+P+P)" placement="topLeft">
              <Button
                className={"ca-quickadd-btn"}
                type={buttonDark(
                  `/billing/clients/${clientId}/purchase/payment`
                )}
              >
                <PlusOutlined />
              </Button>
            </Tooltip>
          </Link>
          <Link
            to={`/billing/clients/${clientId}/purchase/payments`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(
                `/billing/clients/${clientId}/purchase/payments`
              )}
            >
              Payments
            </Button>
          </Link>
        </p>

        <p>
          <Tooltip title="Add Supplier" placement="topLeft">
            <Button
              type="text"
              className={"ca-quickadd-btn"}
              onClick={() => {
                setQuickAddProps({ type: "addSupplier", open: true });
                setOpenQuickAdd(false);
              }}
            >
              <PlusOutlined />
            </Button>
          </Tooltip>
          <Link
            to={`/billing/clients/${clientId}/purchase/suppliers`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(
                `/billing/clients/${clientId}/purchase/suppliers`
              )}
            >
              Suppliers
            </Button>
          </Link>
        </p>

        <p>
          <Tooltip title="Add Items" placement="topLeft">
            <Button
              type="text"
              className={"ca-quickadd-btn"}
              onClick={() => {
                setQuickAddProps({ type: "addItem", open: true });
                setOpenQuickAdd(false);
              }}
            >
              <PlusOutlined />
            </Button>
          </Tooltip>
          <Link
            to={`/billing/clients/${clientId}/purchase/items`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/purchase/items`)}
            >
              Items
            </Button>
          </Link>
        </p>
      </Col>

      <Col sm={8} xs={11}>
        <p style={{ marginBottom: "6px", color: "black" }}>
          <ReadOutlined style={{ padding: "0px 14px 0px 8px" }} />
          Other
        </p>
        <Link
          to={`/billing/clients/${clientId}/journals/add`}
          onClick={() => setOpenQuickAdd(false)}
        >
          <Tooltip title="Add Journal (Alt+J)" placement="topLeft">
            <Button
              className={"ca-quickadd-btn"}
              type={buttonDark(`/billing/clients/${clientId}/journals/add`)}
            >
              <PlusOutlined />
            </Button>
          </Tooltip>
        </Link>
        <Link
          to={`/billing/clients/${clientId}/journals`}
          onClick={() => setOpenQuickAdd(false)}
        >
          <Button
            className={"ca-quickadd-btn"}
            type={buttonDark(`/billing/clients/${clientId}/journals`)}
          >
            Journals
          </Button>
        </Link>
        {/* <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/journals/add`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Alt+L" placement="right">
              <Button
                type={buttonDark(
                  `/billing/clients/${clientId}/ledger`
                )}
              >
                Ledger
              </Button>
            </Tooltip>
          </Link>
        </p> */}
        <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/registers`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Alt+L" placement="right">
              <Button
                type={buttonDark(`/billing/clients/${clientId}/registers`)}
              >
                Registers
              </Button>
            </Tooltip>
          </Link>
        </p>

        <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/trialbalance`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Alt+T" placement="right">
              <Button
                type={buttonDark(`/billing/clients/${clientId}/trialbalance`)}
              >
                Trial Balance
              </Button>
            </Tooltip>
          </Link>
        </p>
        <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/profitAndLoss`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Alt+P+L" placement="right">
              <Button
                type={buttonDark(`/billing/clients/${clientId}/profitAndLoss`)}
              >
                Profit & Loss
              </Button>
            </Tooltip>
          </Link>
        </p>
        <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/BalanceSheet`}
            onClick={() => setOpenQuickAdd(false)}
          >
            <Tooltip title="Alt+B" placement="right">
              <Button
                type={buttonDark(`/billing/clients/${clientId}/BalanceSheet`)}
              >
                Balance Sheet
              </Button>
            </Tooltip>
          </Link>
        </p>
        {/* <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/chartOfAccounts`}
          >
            <Button
              type={buttonDark(
                `/billing/clients/${clientId}/chartOfAccounts`
              )}
            >
              Chart Of Accounts
            </Button>
          </Link>
        </p> */}
        <p style={{ paddingLeft: "20px" }}>
          <Link
            to={`/billing/clients/${clientId}/settings/companyInfo`}
            onClick={() => setOpenQuickAdd(false)}
          >
            {/* title="Shift+S" */}
            <Tooltip placement="right">
              <Button
                type={buttonDark(
                  `/billing/clients/${clientId}/settings/companyInfo`
                )}
              >
                Setting
              </Button>
            </Tooltip>
          </Link>
        </p>
      </Col>
    </Row>
  );

  const content = (
    <div style={{ width: 295 }}>
      <Row
        className="px-3 py-2 linkcolor"
        onClick={() => {
          localStorage.setItem("projecttype", "billing");
          navigate("/billing");
        }}
      >
        <p style={{ cursor: "pointer" }}> Accounting</p>
      </Row>
    </div>
  );
  //#endregion

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  function getItem(
    label: React.ReactNode,
    key: any,
    icon?: React.ReactNode,
    children?: MenuItem[],
    type?: "group"
  ): MenuItem {
    return {
      key,
      icon,
      label,
      type,
    } as MenuItem;
  }

  const MenuAddButton = (
    name: string,
    to: string,
    fn: () => void,
    type: string = "",
    sKey?: string
  ) => {
    return !collapsed ? (
      <Row gutter={[0, 0]}>
        <Col span={showKeys ? 24 : 22}>
          <span
            style={{
              display: "flex",
              position: "relative",
              justifyContent: "space-between",
            }}
          >
            <span> {name}</span>
            <span>
              {showKeys && sKey !== undefined ? (
                <Text
                  // keyboard
                  style={{
                    textAlign: "end",
                    // position: "absolute",
                    // left: 25,
                    // top: 5,
                    // zIndex: "1000000000000!important",
                    // left: 99,
                    width: "50",
                    // backgroundColor: "#00000030",
                  }}
                >
                  {
                    <Tooltip title={sKey}>
                      <kbd>{sKey}</kbd>
                    </Tooltip>
                  }
                </Text>
              ) : (
                ""
              )}
            </span>
          </span>
        </Col>
        <Col span={showKeys ? 0 : 2}>
          {type === "link" ? (
            <Link to={to}>
              <Button
                className="add-icon-button"
                // type="link"
                size="small"
                icon={<PlusOutlined />}
              />
            </Link>
          ) : (
            <Button
              className="add-icon-button"
              // type="link"
              size="small"
              icon={<PlusOutlined />}
              onClick={(e: any) => {
                fn();
              }}
            />
          )}
        </Col>
      </Row>
    ) : (
      name
    );
  };

  const x = getRole();

  console.log("local data allRoleData state, ", loading);

  const getSalesPathByPermission = (clientId: string): string => {
    if (
      findUserPremission(
        ["Voucher.Sales.1.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Invoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/invoices`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.2.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.PInvoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/proformaInvoices`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.3.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.CrNote],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/creditNotes`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.5.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Receipt],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/receipts`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.4.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Quotation],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/estimate`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.6.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.SOrder],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/order`;
    } else {
      return `/billing/clients/${clientId}/sales/customers`;
    }
  };

  const getAddSalesPathByPermission = (clientId: string): string | null => {
    if (
      findUserPremission(
        ["Voucher.Sales.1.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Invoice],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/addInvoice`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.2.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.PInvoice],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/addProformaInvoice`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.3.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.CrNote],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/addCreditNote`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.5.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Receipt],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/addReceipt`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.4.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Quotation],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/addEstimate`;
    } else if (
      findUserPremission(
        ["Voucher.Sales.6.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.SOrder],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/sales/addSalesOrder`;
    }

    return null;
  };

  const getPurchasePathByPermission = (clientId: string): string => {
    if (
      findUserPremission(
        ["Voucher.Purchase.7.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.PurInvoice],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/purchaseBill`;
    } else if (
      findUserPremission(
        ["Voucher.Purchase.8.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.DrNote],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/debitNotes`;
    } else if (
      findUserPremission(
        ["Voucher.Purchase.10.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Payment],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/paymentOut`;
    } else if (
      findUserPremission(
        ["Voucher.Purchase.9.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.POrder],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/purchaseOrder`;
    } else {
      return `/billing/clients/${clientId}/purchase/suppliers`;
    }
  };

  const getAddPurchasePathByPermission = (clientId: string): string | null => {
    if (
      findUserPremission(
        ["Voucher.Purchase.7.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.PurInvoice],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/addPurchaseBill`;
    } else if (
      findUserPremission(
        ["Voucher.Purchase.8.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.DrNote],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/addDebitNote`;
    } else if (
      findUserPremission(
        ["Voucher.Purchase.10.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Payment],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/addPaymentOut`;
    } else if (
      findUserPremission(
        ["Voucher.Purchase.9.Add"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.POrder],
        {
          actionType: IPermissionActionType.Add,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/purchase/addPurchaseOrder`;
    }

    return null;
  };

  const getExpensesPathByPermission = (clientId: string): string => {
    if (
      findUserPremission(
        ["Voucher.Expenses.14.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Expenses],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/expenses`;
    } else if (
      findUserOnlyOnePremission(
        "Master.Ledger.Expenses.View",
        clientSpecificRole(),
        clientId!
      )
    ) {
      return `/billing/clients/${clientId}/expensesLedger`;
    } else if (
      findUserOnlyOnePremission(
        "Master.Group.Expenses.View",
        clientSpecificRole(),
        clientId!
      )
    ) {
      return `/billing/clients/${clientId}/expensesGroup`;
    } else if (
      findUserPremission(
        ["Voucher.Income.15.View"],
        clientSpecificRole(),
        clientId,
        [SettingsSections.Income],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
        }
      )
    ) {
      return `/billing/clients/${clientId}/income`;
    } else if (
      findUserOnlyOnePremission(
        "Master.Ledger.Income.View",
        clientSpecificRole(),
        clientId!
      )
    ) {
      return `/billing/clients/${clientId}/incomeLedger`;
    } else if (
      findUserOnlyOnePremission(
        "Master.Group.Income.View",
        clientSpecificRole(),
        clientId!
      )
    ) {
      return `/billing/clients/${clientId}/incomeGroup`;
    }
    // Page not found
    return "";
  };

  const getSettingsLink = (clientId: string): string => {
    if (
      findUserPremission(
        [
          "Setting.Company.Info.View",
          "Setting.Company.Details.View",
          "Setting.Company.PaymentTerm.View",
          "Setting.Company.GST.View",
        ],
        clientSpecificRole(),
        clientId
      )
    ) {
      return `/billing/clients/${clientId}/settings/companyInfo`;
    } else if (
      findUserPremission(
        [
          "Setting.Voucher.1.View",
          "Setting.Voucher.2.View",
          "Setting.Voucher.3.View",
          "Setting.Voucher.5.View",
          "Setting.Voucher.4.View",
          "Setting.Voucher.6.View",
          "Setting.Voucher.7.View",
          "Setting.Voucher.8.View",
          "Setting.Voucher.10.View",
          "Setting.Voucher.9.View",
          "Setting.Voucher.14.View",
          "Setting.Voucher.15.View",
          "Setting.Voucher.13.View",
          "Setting.Voucher.12.View",
          "Setting.Voucher.11.View",
        ],
        clientSpecificRole(),
        clientId,
        [
          SettingsSections.Invoice,
          SettingsSections.PInvoice,
          SettingsSections.CrNote,
          SettingsSections.Receipt,
          SettingsSections.Quotation,
          SettingsSections.SOrder,
          SettingsSections.PurInvoice,
          SettingsSections.DrNote,
          SettingsSections.Payment,
          SettingsSections.POrder,
          SettingsSections.Expenses,
          SettingsSections.Income,
          SettingsSections.Journal,
          SettingsSections.Contra,
          SettingsSections.Asset,
        ],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.Setting],
        }
      )
    ) {
      return `/billing/clients/${clientId}/settings/vouchers`;
    } else if (
      findUserPremission(["Setting.Item.View"], clientSpecificRole(), clientId)
    ) {
      return `/billing/clients/${clientId}/settings/items`;
    } else if (
      findUserPremission(
        ["Setting.OpeningBalance.View"],
        clientSpecificRole(),
        clientId
      )
    ) {
      return `/billing/clients/${clientId}/settings/openingBalance`;
    } else if (
      findUserPremission(
        ["Setting.Templates.View"],
        clientSpecificRole(),
        clientId
      )
    ) {
      return `/billing/clients/${clientId}/settings/templates`;
    } else if (
      findUserPremission(
        ["Setting.DefaultLedger.View"],
        clientSpecificRole(),
        clientId
      )
    ) {
      return `/billing/clients/${clientId}/settings/defaultLedger`;
    } else if (
      findUserPremission(
        [
          "Setting.TC.1.View",
          "Setting.TC.2.View",
          "Setting.TC.3.View",
          "Setting.TC.5.View",
          "Setting.TC.4.View",
          "Setting.TC.6.View",
          "Setting.TC.7.View",
          "Setting.TC.8.View",
          "Setting.TC.10.View",
          "Setting.TC.9.View",
          "Setting.TC.14.View",
          "Setting.TC.15.View",
          "Setting.TC.13.View",
          "Setting.TC.12.View",
          "Setting.TC.11.View",
        ],
        clientSpecificRole(),
        clientId,
        [
          SettingsSections.Invoice,
          SettingsSections.PInvoice,
          SettingsSections.CrNote,
          SettingsSections.Receipt,
          SettingsSections.Quotation,
          SettingsSections.SOrder,
          SettingsSections.PurInvoice,
          SettingsSections.DrNote,
          SettingsSections.Payment,
          SettingsSections.POrder,
          SettingsSections.Expenses,
          SettingsSections.Income,
          SettingsSections.Journal,
          SettingsSections.Contra,
          SettingsSections.Asset,
        ],
        {
          actionType: IPermissionActionType.View,
          dataType: [ITypeIIsClientSpecificRoleDataType.TandC],
        }
      )
    ) {
      return `/billing/clients/${clientId}/settings/termsandConditions`;
    } else if (
      findUserPremission(
        ["Setting.Currencies.View"],
        clientSpecificRole(),
        clientId
      )
    ) {
      return `/billing/clients/${clientId}/settings/currencies`;
    } else if (
      findUserPremission(
        ["Setting.LockMonth.View"],
        clientSpecificRole(),
        clientId
      )
    ) {
      return `/billing/clients/${clientId}/settings/lockmonth`;
    } else if (
      findUserPremission(["Setting.TDS.View"], clientSpecificRole(), clientId)
    ) {
      return `/billing/clients/${clientId}/settings/tds`;
    } else {
      return `/billing/clients/${clientId}/settings/tcs`;
    }
  };

  const items: MenuItem[] =
    loading && clientSpecificRole()
      ? []
      : [
          // ...(loginUser?.companyList?.length === 1
          //   ? []
          // :
          //  [
          getItem(
            <Link
              to={"/billing"}
              onClick={() => {
                if (JSON.parse(localStorage.getItem("LockPeriod")!)) {
                  localStorage.removeItem("LockPeriod");
                }
              }}
            >
              All Clients
            </Link>,
            "/billing",
            <div>
              <AllClientIcon
                active={forActndInActive(`/billing`)}
                color={themeData?.themeData?.themeColor}
              />
            </div>
          ),
          // ]),
          // Dashboard
          ...(findUserPremission(
            ["Dashboard.View"],
            clientSpecificRole(),
            clientId
            // allRoleData
          )
            ? [
                getItem(
                  <Link
                    to={`/billing/clients/${clientId}/dashboard`}
                    className="Customize"
                  >
                    Dashboard
                  </Link>,

                  `/billing/clients/${clientId}/dashboard`,
                  // <AiOutlineDashboard style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="dashbrd"
                  //   src={dash}
                  //   // style={{ marginRight: "6px" }}
                  // />
                  <div>
                    <DashBoardIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/dashboard`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // party
          ...(findUserPremission(
            ["Master.Ledger.Party.View", "Master.Group.Party.View"],
            clientSpecificRole(),
            clientId
          )
            ? [
                getItem(
                  <Link
                    to={
                      findUserPremission(
                        ["Master.Ledger.Party.View"],
                        clientSpecificRole(),
                        clientId
                      )
                        ? `/billing/clients/${clientId}/party/parties`
                        : `/billing/clients/${clientId}/party/partiesGroup`
                    }
                    className="Customize"
                  >
                    {findUserPremission(
                      ["Master.Ledger.Party.Add"],
                      clientSpecificRole(),
                      clientId
                    )
                      ? MenuAddButton(
                          "Parties",
                          `/billing/clients/${clientId}/party`,
                          () => {
                            setQuickAddProps({
                              type: "AddParty",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.PartiesOnly,
                            });
                          },
                          "",
                          "CTRL+SHIFT+F1"
                        )
                      : findUserPremission(
                          ["Master.Group.Party.Add"],
                          clientSpecificRole(),
                          clientId
                        )
                      ? MenuAddButton(
                          "Parties",
                          `/billing/clients/${clientId}/party`,
                          () => {
                            setQuickAddProps({
                              type: "AddGroup",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.PartiesOnly,
                            });
                          },
                          "",
                          "CTRL+SHIFT+F1"
                        )
                      : "Parties"}
                  </Link>,
                  `/billing/clients/${clientId}/party`,
                  // <AiOutlineDashboard style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="dashbrd"
                  //   src={pur}
                  //   // style={{ marginRight: "6px" }}
                  // />
                  <div>
                    <PartiesIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/party`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),
          // item
          ...(findUserPremission(
            [
              "Master.Item.View",
              "Master.Item.Category.View",
              "Master.Item.Unit.View",
              "Master.Item.Locations.View",
            ],
            clientSpecificRole(),
            clientId
          )
            ? [
                getItem(
                  <Link
                    to={
                      findUserPremission(
                        ["Master.Item.View"],
                        clientSpecificRole(),
                        clientId
                      )
                        ? `/billing/clients/${clientId}/item/items`
                        : findUserPremission(
                            ["Master.Item.Category.View"],
                            clientSpecificRole(),
                            clientId
                          )
                        ? `/billing/clients/${clientId}/item/itemCategory`
                        : findUserPremission(
                            ["Master.Item.Unit.View"],
                            clientSpecificRole(),
                            clientId
                          )
                        ? `/billing/clients/${clientId}/item/units`
                        : `/billing/clients/${clientId}/item/itemlocations`
                    }
                    className="Customize"
                  >
                    {findUserPremission(
                      ["Master.Item.Add"],
                      clientSpecificRole(),
                      clientId
                    )
                      ? MenuAddButton(
                          "Items",
                          `/billing/clients/${clientId}/item`,
                          () => {
                            setQuickAddProps({
                              type: "addItem",
                              open: true,
                            });
                          },
                          "",
                          "CTRL+SHIFT+I"
                        )
                      : findUserPremission(
                          ["Master.Item.Category.Add"],
                          clientSpecificRole(),
                          clientId
                        )
                      ? MenuAddButton(
                          "Items",
                          `/billing/clients/${clientId}/item`,
                          () => {
                            setQuickAddProps({
                              type: "addCategory",
                              open: true,
                            });
                          },
                          "",
                          "CTRL+SHIFT+I"
                        )
                      : findUserPremission(
                          ["Master.Item.Unit.Add"],
                          clientSpecificRole(),
                          clientId
                        )
                      ? MenuAddButton(
                          "Items",
                          `/billing/clients/${clientId}/item`,
                          () => {
                            setQuickAddProps({
                              type: "addUnit",
                              open: true,
                            });
                          },
                          "",
                          "CTRL+SHIFT+I"
                        )
                      : MenuAddButton(
                          "Items",
                          `/billing/clients/${clientId}/item`,
                          () => {
                            setQuickAddProps({
                              type: "addLocation",
                              open: true,
                            });
                          },
                          "",
                          "CTRL+SHIFT+I"
                        )}
                  </Link>,
                  `/billing/clients/${clientId}/item`,
                  // <AiOutlineDashboard style={{ color: "#3a5dd3" }} />
                  <div>
                    <ItemIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/item`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // sales
          ...(findUserPremission(
            [
              "Voucher.Sales.1.View",
              "Voucher.Sales.2.View",
              "Voucher.Sales.3.View",
              "Voucher.Sales.5.View",
              "Voucher.Sales.4.View",
              "Voucher.Sales.6.View",
              "Master.Ledger.Customer.View",
            ],
            clientSpecificRole(),
            clientId,
            [
              SettingsSections.Invoice,
              SettingsSections.PInvoice,
              SettingsSections.CrNote,
              SettingsSections.Receipt,
              SettingsSections.Quotation,
              SettingsSections.SOrder,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link to={getSalesPathByPermission(clientId!)}>
                    {/* <Tooltip
          title={
            <>
              Add Invoice
              <br />
              <Tag >
                <kbd>Shift + F5</kbd>
              </Tag>
            </>
          }
        > */}
                    {getAddSalesPathByPermission(clientId!)
                      ? MenuAddButton(
                          "Sales",
                          getAddSalesPathByPermission(clientId!)!,
                          () => {},
                          "link",
                          "SHIFT+F5"
                        )
                      : findUserPremission(
                          ["Master.Ledger.Customer.View"],
                          clientSpecificRole(),
                          clientId!
                        )
                      ? MenuAddButton(
                          "Sales",
                          `/billing/clients/${clientId}/sales/customers`,
                          () => {
                            setQuickAddProps({
                              type: "addLedger",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.CreditorsOnly,
                            });
                          },
                          "",
                          "CTRL+SHIFT+L"
                        )
                      : "Sales"}
                    {/* </Tooltip> */}
                  </Link>,
                  // `/billing/clients/${clientId}/sales/invoices`,
                  `/billing/clients/${clientId}/sales`,
                  // <BsCurrencyRupee style={{ color: "#3a5dd3" }} />
                  <div>
                    <SalesIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/sales`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),
          // purchase
          ...(findUserPremission(
            [
              "Voucher.Purchase.7.View",
              "Voucher.Purchase.8.View",
              "Voucher.Purchase.10.View",
              "Voucher.Purchase.9.View",
              "Master.Ledger.Suppliers.View",
            ],
            clientSpecificRole(),
            clientId,
            [
              SettingsSections.PurInvoice,
              SettingsSections.DrNote,
              SettingsSections.Payment,
              SettingsSections.POrder,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link to={getPurchasePathByPermission(clientId!)}>
                    {getAddPurchasePathByPermission(clientId!)
                      ? MenuAddButton(
                          "Purchase",
                          getAddPurchasePathByPermission(clientId!)!,
                          () => {},
                          "link",
                          "SHIFT+F9"
                        )
                      : findUserPremission(
                          ["Master.Ledger.Suppliers.Add"],
                          clientSpecificRole(),
                          clientId!
                        )
                      ? MenuAddButton(
                          "Purchase",
                          `/billing/clients/${clientId}/sales/suppliers`,
                          () => {
                            setQuickAddProps({
                              type: "addLedger",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.DebtorsOnly,
                            });
                          },
                          ""
                        )
                      : "Purchase"}

                    {/* </Tooltip> */}
                  </Link>,
                  // `/billing/clients/${clientId}/purchase/purchaseBill`,
                  `/billing/clients/${clientId}/purchase`,
                  // <BiCube style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="purchaselogo"
                  //   src={purchaselogo}
                  //   style={{ height: "20px", width: "21px" }}
                  // />
                  <div>
                    <PurchaseIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/purchase`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // expenses & income
          ...(findUserPremission(
            [
              "Voucher.Expenses.14.View",
              "Voucher.Income.15.View",

              "Master.Ledger.Expenses.View",
              "Master.Ledger.Income.View",

              "Master.Group.Expenses.View",
              "Master.Group.Income.View",
            ],
            clientSpecificRole(),
            clientId,
            [SettingsSections.Expenses, SettingsSections.Income],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link
                    to={getExpensesPathByPermission(clientId!)}
                    className="Customize"
                  >
                    {findUserPremission(
                      ["Voucher.Expenses.14.Add"],
                      clientSpecificRole(),
                      clientId,
                      [SettingsSections.Expenses],
                      {
                        actionType: IPermissionActionType.Add,
                        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                      }
                    )
                      ? MenuAddButton(
                          "Expense & Income",
                          `/billing/clients/${clientId}/expenses/addExpenses`,
                          () => {},
                          "link",
                          "SHIFT+F3"
                        )
                      : findUserPremission(
                          ["Voucher.Income.15.Add"],
                          clientSpecificRole(),
                          clientId,
                          [SettingsSections.Income],
                          {
                            actionType: IPermissionActionType.Add,
                            dataType: [
                              ITypeIIsClientSpecificRoleDataType.Vouchers,
                            ],
                          }
                        )
                      ? MenuAddButton(
                          "Expense & Income",
                          `/billing/clients/${clientId}/income/addIncome`,
                          () => {},
                          "link"
                        )
                      : findUserOnlyOnePremission(
                          "Master.Ledger.Expenses.Add",
                          clientSpecificRole(),
                          clientId!
                        )
                      ? MenuAddButton(
                          "Expense & Income",
                          `/billing/clients/${clientId}/expenses/expensesLedger`,
                          () => {
                            setQuickAddProps({
                              type: "addLedger",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.AllExpenses,
                            });
                          },
                          ""
                        )
                      : findUserOnlyOnePremission(
                          "Master.Group.Expenses.Add",
                          clientSpecificRole(),
                          clientId!
                        )
                      ? MenuAddButton(
                          "Expense & Income",
                          `/billing/clients/${clientId}/expensesGroup`,
                          () => {
                            setQuickAddProps({
                              type: "addGroup",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.AllExpenses,
                            });
                          },
                          ""
                        )
                      : findUserOnlyOnePremission(
                          "Master.Ledger.Income.Add",
                          clientSpecificRole(),
                          clientId!
                        )
                      ? MenuAddButton(
                          "Expense & Income",
                          `/billing/clients/${clientId}/incomeLedger`,
                          () => {
                            setQuickAddProps({
                              type: "addLedger",
                              open: true,
                              iType:
                                SearchLedgerByGroupsTypes.IndirectIncomeOnly,
                            });
                          },
                          ""
                        )
                      : findUserOnlyOnePremission(
                          "Master.Group.Income.Add",
                          clientSpecificRole(),
                          clientId!
                        )
                      ? MenuAddButton(
                          "Expense & Income",
                          `/billing/clients/${clientId}/incomeGroup`,
                          () => {
                            setQuickAddProps({
                              type: "addGroup",
                              open: true,
                              iType:
                                SearchLedgerByGroupsTypes.IndirectIncomeOnly,
                            });
                          },
                          ""
                        )
                      : "Cost Centres"}
                  </Link>,
                  `/billing/clients/${clientId}/expenses`,
                  // <AiOutlineDashboard style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="dashbrd"
                  //   src={dashbrd}
                  //   style={{ height: "20px", width: "15px", marginRight: "6px" }}
                  // />
                  <div>
                    <ExpndIncIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/expenses`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // journals
          ...(findUserPremission(
            ["Voucher.Journal.12.View"],
            clientSpecificRole(),
            clientId,
            [SettingsSections.Journal],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link to={`/billing/clients/${clientId}/journals`}>
                    {findUserPremission(
                      ["Voucher.Journal.12.Add"],
                      clientSpecificRole(),
                      clientId,
                      [SettingsSections.Journal],
                      {
                        actionType: IPermissionActionType.Add,
                        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                      }
                    )
                      ? MenuAddButton(
                          "Journal",
                          `/billing/clients/${clientId}/journals/add`,
                          () => {},
                          "link"
                        )
                      : "Journal"}
                    {/* </Tooltip> */}
                  </Link>,
                  `/billing/clients/${clientId}/journals`,
                  // <BookOutlined style={{ color: "#3a5dd3" }} />
                  <div>
                    <JournalIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/journals`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),
          // cash & bank
          ...(findUserPremission(
            [
              "Voucher.Contra.13.View",
              "Master.Ledger.Bank.View",
              "Master.Ledger.Cash.View",
              "Master.BankReconciliation.View",
              "Master.LoanAccount.View",
              "Master.Cheque.View",
            ],
            clientSpecificRole(),
            clientId,
            [SettingsSections.Contra],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link
                    to={
                      findUserPremission(
                        [
                          "Voucher.Contra.13.Add",
                          "Master.Ledger.Bank.View",
                          "Master.Ledger.Cash.View",
                        ],
                        clientSpecificRole(),
                        clientId,
                        [SettingsSections.Contra],
                        {
                          actionType: IPermissionActionType.Add,
                          dataType: [
                            ITypeIIsClientSpecificRoleDataType.Vouchers,
                          ],
                        }
                      )
                        ? `/billing/clients/${clientId}/banking/bankAccounts`
                        : findUserOnlyOnePremission(
                            "Master.BankReconciliation.View",
                            clientSpecificRole(),
                            clientId!
                          )
                        ? `/billing/clients/${clientId}/banking/bankReconciliation`
                        : `/billing/clients/${clientId}/banking/cheque`
                    }
                  >
                    {/* <Tooltip
          title={
            <>
              Add Transfer Entry
              <br />
              <Tag >
                <kbd>SHIFT+F4</kbd>
              </Tag>
            </>
          }
        > */}
                    {findUserPremission(
                      ["Master.Ledger.Bank.Add", "Master.Ledger.Cash.Add"],
                      clientSpecificRole(),
                      clientId,
                      [SettingsSections.Contra],
                      {
                        actionType: IPermissionActionType.Add,
                        dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
                      }
                    )
                      ? MenuAddButton(
                          "Cash & Bank",
                          `/billing/clients/${clientId}/banking/bankAccounts`,
                          () => {
                            setQuickAddProps({
                              type: "AdjustBankBalanceModel",
                              open: true,
                            });
                          },
                          "",
                          "SHIFT+F4"
                        )
                      : "Cash & Bank"}
                    {/* </Tooltip> */}
                  </Link>,
                  `/billing/clients/${clientId}/banking`,
                  // <img
                  //   alt="Bank"
                  //   src={bankImg}
                  //   style={{ height: "19px", width: "15px", marginRight: "6px" }}
                  // />
                  <div>
                    <CashndBankIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/banking`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // assetPurchase

          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/sharecapital/sharecapital`}
          //   >
          //     Share Capital
          //   </Link>,
          //   `/billing/clients/${clientId}/sharecapital/sharecapital`,
          //   <FileSearchOutlined />
          // ),

          // getItem(
          //   collapsed ? (
          //     <Divider className="divider-m0" />
          //   ) : (
          //     <b style={{ color: "black" }}>Automation</b>
          //   ),
          //   "automation",
          //   null,
          //   [
          //     getItem(
          //       <Link to={`/billing/clients/${clientId}/bankRules`}>
          //         Bank Rules
          //       </Link>,
          //       `/billing/clients/${clientId}/bankRules`,
          //       <HiOutlineNewspaper />
          //     ),
          //     getItem(
          //       <Link to={`/billing/clients/${clientId}/gstReturn`}>
          //         GST Return
          //       </Link>,
          //       `/billing/clients/${clientId}/gstReturn`,
          //       <PercentageOutlined />
          //     ),
          //   ],
          //   "group"
          // ),
          // getItem(
          //   collapsed ? (
          //     <Divider />
          //   ) : (
          //     // <Typography.Title
          //     //   level={5}
          //     //   style={{
          //     //     // color: "#395cd2",
          //     //     color: "#44546F",
          //     //     fontWeight: 600,
          //     //     fontSize: "15px",
          //     //   }}
          //     // >
          //     //   Reports
          //     // </Typography.Title>
          //     <></>
          //   ),
          //   "report",
          //   null,
          //   [
          // getItem(
          //   <Link to={`/billing/clients/${clientId}/ledger`}>
          //     Ledger
          //   </Link>,
          //   `/billing/clients/${clientId}/ledger`,
          //   <BookOutlined style={{ color: "#3a5dd3" }} />
          // ),
          // getItem(
          //   <Link to={`/billing/clients/${clientId}/ledgernew`}>
          //     Ledger
          //   </Link>,
          //   `/billing/clients/${clientId}/ledgernew`,
          //     <img src={ledger} style={{height:'18px', width:'16px'}} />
          // ),
          ...(findUserPremission(
            [
              "Voucher.Asset.11.View",
              "Voucher.Asset.DisposedAsset.View",
              "Master.AssestsLocation.View",
            ],
            clientSpecificRole(),
            clientId,
            [SettingsSections.Asset],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link to={`/billing/clients/${clientId}/asset/assetPurchase`}>
                    {MenuAddButton(
                      "Assets",
                      `/billing/clients/${clientId}/asset/addFixedAsset`,
                      () => {},
                      "link"
                    )}
                  </Link>,
                  `/billing/clients/${clientId}/asset`,
                  // <TbBuildingCommunity style={{ color: "#3a5dd3" }} />
                  <div>
                    <AssetIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/asset`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // draft
          ...(findUserPremission(
            [
              "Voucher.Sales.1.View",
              "Voucher.Sales.2.View",
              "Voucher.Sales.3.View",
              "Voucher.Sales.5.View",
              "Voucher.Sales.4.View",
              "Voucher.Sales.6.View",

              "Voucher.Purchase.7.View",
              "Voucher.Purchase.8.View",
              "Voucher.Purchase.10.View",
              "Voucher.Purchase.9.View",

              "Voucher.Expenses.14.View",
              "Voucher.Income.15.View",

              "Voucher.Journal.12.View",

              "Voucher.Contra.13.View",

              "Voucher.Asset.11.View",
            ],
            clientSpecificRole(),
            clientId,
            [
              SettingsSections.Invoice,
              SettingsSections.PInvoice,
              SettingsSections.CrNote,
              SettingsSections.Receipt,
              SettingsSections.Quotation,
              SettingsSections.SOrder,

              // Purchase
              SettingsSections.PurInvoice,
              SettingsSections.DrNote,
              SettingsSections.Payment,
              SettingsSections.POrder,

              // expenses & income
              SettingsSections.Expenses,
              SettingsSections.Income,

              // Journal
              SettingsSections.Journal,
              // Contra
              SettingsSections.Contra,
              // Asset
              SettingsSections.Asset,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link to={`/billing/clients/${clientId}/draft`}>Draft</Link>,
                  `/billing/clients/${clientId}/draft`,
                  <div>
                    <DraftIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/draft`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // registers
          ...(findUserPremission(
            [
              "Voucher.Sales.1.View",
              "Voucher.Sales.2.View",
              "Voucher.Sales.3.View",
              "Voucher.Sales.5.View",
              "Voucher.Sales.4.View",
              "Voucher.Sales.6.View",

              "Voucher.Purchase.7.View",
              "Voucher.Purchase.8.View",
              "Voucher.Purchase.10.View",
              "Voucher.Purchase.9.View",

              "Voucher.Expenses.14.View",
              "Voucher.Income.15.View",

              "Voucher.Journal.12.View",

              "Voucher.Contra.13.View",

              "Voucher.Asset.11.View",
            ],
            clientSpecificRole(),
            clientId,
            [
              SettingsSections.Invoice,
              SettingsSections.PInvoice,
              SettingsSections.CrNote,
              SettingsSections.Receipt,
              SettingsSections.Quotation,
              SettingsSections.SOrder,

              // Purchase
              SettingsSections.PurInvoice,
              SettingsSections.DrNote,
              SettingsSections.Payment,
              SettingsSections.POrder,

              // expenses & income
              SettingsSections.Expenses,
              SettingsSections.Income,

              // Journal
              SettingsSections.Journal,
              // Contra
              SettingsSections.Contra,
              // Asset
              SettingsSections.Asset,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [ITypeIIsClientSpecificRoleDataType.Vouchers],
            }
          )
            ? [
                getItem(
                  <Link to={`/billing/clients/${clientId}/registers`}>
                    Registers
                  </Link>,
                  `/billing/clients/${clientId}/registers`,
                  // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="journals"
                  //   src={journals}
                  //   style={{ height: "19px", width: "15px", marginRight: "6px" }}
                  // />

                  <div>
                    <RegIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/registers`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // repost
          ...(findUserPremission(
            [
              "Report.BalanceSheet.View",
              "Report.P&L.View",
              "Report.TrialBalance.View",
              "Report.CashFlow.View",
              "Report.DebtorsAgeing.View",
              "Report.CreditorsAgeing.View",
              "Report.CustomerOutstanding.View",
              "Report.SupplierOutstanding.View",
              "Report.GeneralLedger.View",
              "Report.FixedAssets.View",
              "Report.BankReconciliation.View",
              "Report.GST.View",
              "Report.Tds.View",
              "Report.Tcs.View",
            ],
            clientSpecificRole(),
            clientId
          )
            ? [
                getItem(
                  <Link to={`/billing/clients/${clientId}/reports`}>
                    Reports
                  </Link>,
                  `/billing/clients/${clientId}/reports`,
                  // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
                  <div>
                    <ReportIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/reports`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // others
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/reports/ageing/debtors`}
          //   >
          //     Ageing Report
          //   </Link>,
          //   `/billing/clients/${clientId}/reports/ageing`,
          //   // <BsGraphUpArrow />
          //   // <HiOutlineChartPie style={{ color: "#3a5dd3" }} />
          //   <img src={agegingreport} style={{ height: "20px", width: "20px" }} />
          // ),

          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/generalLedger`}
          //   >
          //     General Ledger
          //   </Link>,
          //   `/billing/clients/${clientId}/generalLedger`,
          //   // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
          //   <img
          //     alt="journals"
          //     src={journals}
          //     style={{ height: "19px", width: "15px", marginRight: "6px" }}
          //   />
          // ),
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/trialbalance`}
          //   >
          //     Trial Balance
          //   </Link>,
          //   `/billing/clients/${clientId}/trialbalance`,
          //   <MdOutlineBalance style={{ color: "#3a5dd3" }} />
          // ),
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/trialbalancenew`}
          //   >
          //     Trial Balance
          //   </Link>,
          //   `/billing/clients/${clientId}/trialbalancenew`,
          //   // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
          //   <img
          //     alt="trialbal"
          //     src={trialbal}
          //     style={{ height: "20px", width: "18px", marginRight: "8px" }}
          //   />
          // ),
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/profitAndLoss`}
          //   >
          //     Profit and Loss
          //   </Link>,
          //   `/billing/clients/${clientId}/profitAndLoss`,
          //   <HiOutlineChartPie style={{ color: "#3a5dd3" }} />
          // ),
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/profitAndLossnew`}
          //   >
          //     Profit and Loss
          //   </Link>,
          //   `/billing/clients/${clientId}/profitAndLossnew`,
          //   <img
          //     alt="profitloss"
          //     src={profitloss}
          //     style={{ height: "20px", width: "20px", marginRight: "8px" }}
          //   />
          // ),
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/BalanceSheet`}
          //   >
          //     Balance Sheet
          //   </Link>,
          //   `/billing/clients/${clientId}/BalanceSheet`,
          //   // <IoMdPaper style={{ color: "#3a5dd3" }} />
          //   <img
          //     alt="balancesheet"
          //     src={balancesheet}
          //     style={{ height: "20px", width: "20px", marginRight: "8px" }}
          //   />
          // ),
          // getItem(
          //   <Link
          //     to={`/billing/clients/${clientId}/ageing/debtors`}

          //   >
          //     Ageing Report
          //   </Link>,
          //   `/billing/clients/${clientId}/ageing`,
          //   // <BsGraphUpArrow />
          //   // <HiOutlineChartPie style={{ color: "#3a5dd3" }} />
          //   <img src={agegingreport} style={{ height: "20px", width: "20px" }} />
          // ),
          ...(findUserPremission(
            [
              "Master.Ledger.View",
              "Master.Group.View",
              "Setting.Company.Info.View",
              "Setting.Company.Details.View",
              "Setting.Company.PaymentTerm.View",
              "Setting.Company.GST.View",

              "Setting.Voucher.1.View",
              "Setting.Voucher.2.View",
              "Setting.Voucher.3.View",
              "Setting.Voucher.5.View",
              "Setting.Voucher.4.View",
              "Setting.Voucher.6.View",

              "Setting.Voucher.7.View",
              "Setting.Voucher.8.View",
              "Setting.Voucher.10.View",
              "Setting.Voucher.9.View",

              "Setting.Voucher.14.View",
              "Setting.Voucher.15.View",

              "Setting.Voucher.13.View",
              "Setting.Voucher.12.View",
              "Setting.Voucher.11.View",

              "Setting.Item.View",
              "Setting.OpeningBalance.View",
              "Setting.Templates.View",
              "Setting.DefaultLedger.View",

              "Setting.TC.1.View",
              "Setting.TC.2.View",
              "Setting.TC.3.View",
              "Setting.TC.5.View",
              "Setting.TC.4.View",
              "Setting.TC.6.View",
              "Setting.TC.7.View",
              "Setting.TC.8.View",
              "Setting.TC.10.View",
              "Setting.TC.9.View",
              "Setting.TC.14.View",
              "Setting.TC.15.View",
              "Setting.TC.13.View",
              "Setting.TC.12.View",
              "Setting.TC.11.View",

              "Setting.TDS.View",
              "Setting.TCS.View",

              "Setting.Currencies.View",
            ],
            clientSpecificRole(),
            clientId,
            [
              SettingsSections.Invoice,
              SettingsSections.PInvoice,
              SettingsSections.CrNote,
              SettingsSections.Receipt,
              SettingsSections.Quotation,
              SettingsSections.SOrder,

              // Purchase
              SettingsSections.PurInvoice,
              SettingsSections.DrNote,
              SettingsSections.Payment,
              SettingsSections.POrder,

              // expenses & income
              SettingsSections.Expenses,
              SettingsSections.Income,

              // Journal
              SettingsSections.Journal,
              // Contra
              SettingsSections.Contra,
              // Asset
              SettingsSections.Asset,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [
                ITypeIIsClientSpecificRoleDataType.Setting,
                ITypeIIsClientSpecificRoleDataType.TandC,
              ],
            }
          )
            ? [
                getItem(
                  collapsed ? (
                    <Divider className="divider-m0" />
                  ) : (
                    <Typography.Title
                      level={5}
                      style={{
                        // color: "#395cd2",
                        color: "black",
                        fontWeight: 600,
                        fontSize: "15px",
                      }}
                    >
                      Other
                    </Typography.Title>
                  ),
                  "other"
                  // null,
                  // [
                  //   // getItem(
                  //   //   <Link
                  //   //     to={`/billing/clients/${clientId}/baking/banks`}
                  //   //   >
                  //   //     Banking
                  //   //   </Link>,
                  //   //   `/billing/clients/${clientId}/baking/banks`,
                  //   //   <BankOutlined style={{ color: "#3a5dd3" }} />
                  //   // ),
                  //   // getItem(
                  //   //   <Link
                  //   //     to={`/billing/clients/${clientId}/openingbalance`}
                  //   //   >
                  //   //     Opening Balance
                  //   //   </Link>,
                  //   //   `/billing/clients/${clientId}/openingbalance`,
                  //   //   <InsertRowBelowOutlined style={{ color: "#3a5dd3" }} />
                  //   // ),
                  //   // getItem(
                  //   //   <Link
                  //   //     to={`/billing/clients/${clientId}/chartOfAccounts`}
                  //   //   >
                  //   //     Chart of Accounts
                  //   //   </Link>,
                  //   //   `/billing/clients/${clientId}/chartOfAccounts`,
                  //   //   // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
                  //   //   <img
                  //   //     src={chartofaccounts}
                  //   //     style={{ height: "20px", width: "20px" }}
                  //   //   />
                  //   // ),
                  //   getItem(
                  //     <Link to={`/billing/clients/${clientId}/settings/companyInfo`}>
                  //       Settings
                  //     </Link>,
                  //     `/billing/clients/${clientId}/settings`,
                  //     // <SettingOutlined style={{ color: "#3a5dd3" }} />
                  //     <img
                  //       alt="settingslogo"
                  //       src={settingslogo}
                  //       style={{ height: "20px", width: "20px", marginRight: "8px" }}
                  //     />
                  //   ),
                  // ],
                  // "group"
                ),
              ]
            : []),

          // master
          ...(findUserPremission(
            ["Master.Ledger.View", "Master.Group.View"],
            clientSpecificRole(),
            clientId
          )
            ? [
                getItem(
                  <Link
                    to={
                      findUserPremission(
                        ["Master.Ledger.View"],
                        clientSpecificRole(),
                        clientId
                      )
                        ? `/billing/clients/${clientId}/master/ledger`
                        : `/billing/clients/${clientId}/master/group`
                    }
                  >
                    {findUserPremission(
                      ["Master.Ledger.Add"],
                      clientSpecificRole(),
                      clientId
                    )
                      ? MenuAddButton(
                          "Master",
                          `/billing/clients/${clientId}/master`,
                          () => {
                            setQuickAddProps({
                              type: "AddLedger",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.All,
                            });
                          },
                          "",
                          "CTRL+SHIFT+L"
                        )
                      : findUserPremission(
                          ["Master.Group.Add"],
                          clientSpecificRole(),
                          clientId
                        )
                      ? MenuAddButton(
                          "Master",
                          `/billing/clients/${clientId}/master`,
                          () => {
                            setQuickAddProps({
                              type: "AddGroup",
                              open: true,
                              iType: SearchLedgerByGroupsTypes.All,
                            });
                          },
                          "",
                          "CTRL+SHIFT+L"
                        )
                      : "Master"}
                  </Link>,
                  `/billing/clients/${clientId}/master`,
                  // <UsergroupAddOutlined style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="masters"
                  //   src={masters}
                  //   style={{ height: "20px", width: "15px", marginRight: "6px" }}
                  // />
                  <div>
                    <MasterIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/master`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          // setting
          ...(findUserPremission(
            [
              "Setting.Company.Info.View",
              "Setting.Company.Details.View",
              "Setting.Company.PaymentTerm.View",
              "Setting.Company.GST.View",

              "Setting.Voucher.1.View",
              "Setting.Voucher.2.View",
              "Setting.Voucher.3.View",
              "Setting.Voucher.5.View",
              "Setting.Voucher.4.View",
              "Setting.Voucher.6.View",

              "Setting.Voucher.7.View",
              "Setting.Voucher.8.View",
              "Setting.Voucher.10.View",
              "Setting.Voucher.9.View",

              "Setting.Voucher.14.View",
              "Setting.Voucher.15.View",

              "Setting.Voucher.13.View",
              "Setting.Voucher.12.View",
              "Setting.Voucher.11.View",

              "Setting.Item.View",
              "Setting.OpeningBalance.View",
              "Setting.Templates.View",
              "Setting.DefaultLedger.View",

              "Setting.TC.1.View",
              "Setting.TC.2.View",
              "Setting.TC.3.View",
              "Setting.TC.5.View",
              "Setting.TC.4.View",
              "Setting.TC.6.View",
              "Setting.TC.7.View",
              "Setting.TC.8.View",
              "Setting.TC.10.View",
              "Setting.TC.9.View",
              "Setting.TC.14.View",
              "Setting.TC.15.View",
              "Setting.TC.13.View",
              "Setting.TC.12.View",
              "Setting.TC.11.View",

              "Setting.TDS.View",
              "Setting.TCS.View",

              "Setting.Currencies.View",
              "Setting.LockMonth.View",
            ],
            clientSpecificRole(),
            clientId,
            [
              SettingsSections.Invoice,
              SettingsSections.PInvoice,
              SettingsSections.CrNote,
              SettingsSections.Receipt,
              SettingsSections.Quotation,
              SettingsSections.SOrder,

              // Purchase
              SettingsSections.PurInvoice,
              SettingsSections.DrNote,
              SettingsSections.Payment,
              SettingsSections.POrder,

              // expenses & income
              SettingsSections.Expenses,
              SettingsSections.Income,

              // Journal
              SettingsSections.Journal,
              // Contra
              SettingsSections.Contra,
              // Asset
              SettingsSections.Asset,
            ],
            {
              actionType: IPermissionActionType.View,
              dataType: [
                ITypeIIsClientSpecificRoleDataType.Setting,
                ITypeIIsClientSpecificRoleDataType.TandC,
              ],
            }
          )
            ? [
                getItem(
                  <Link to={getSettingsLink(clientId!)}>Settings</Link>,
                  `/billing/clients/${clientId}/settings`,
                  // <SettingOutlined style={{ color: "#3a5dd3" }} />
                  // <img
                  //   alt="settingslogo"
                  //   src={settingslogo}
                  //   style={{ height: "20px", width: "20px", marginRight: "2px" }}
                  // />
                  <div>
                    <SettingIcon
                      active={forActndInActive(
                        `/billing/clients/${clientId}/settings`
                      )}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                ),
              ]
            : []),

          getItem(
            <Link
              to={`/billing/clients/${clientId}/roles`}
              className="Customize"
            >
              Roles
            </Link>,

            `/billing/clients/${clientId}/roles`,
            // <AiOutlineDashboard style={{ color: "#3a5dd3" }} />
            // <img
            //   alt="dashbrd"
            //   src={dash}
            //   // style={{ marginRight: "6px" }}
            // />
            <div>
              <DashBoardIcon
                active={forActndInActive(`/billing/clients/${clientId}/roles`)}
                color={themeData?.themeData?.themeColor}
              />
            </div>
          ),
          getItem(
            <Link
              to={`/billing/clients/${clientId}/organisations/organisations`}
              className="Customize"
            >
              Organisations
            </Link>,

            `/billing/clients/${clientId}/organisations/organisations`,
            <div>
              <DashBoardIcon
                active={forActndInActive(
                  `/billing/clients/${clientId}/organisations`
                )}
                color={themeData?.themeData?.themeColor}
              />
            </div>
          ),
        ];
  const invItems: MenuItem[] = [
    getItem(
      <Link
        to={`/billing/clients/${clientId}/dashboard`}
        style={{ color: "#44546F" }}
        onClick={() => {
          if (JSON.parse(localStorage.getItem("LockPeriod")!)) {
            localStorage.removeItem("LockPeriod");
          }
        }}
      >
        Client
      </Link>,
      `/billing/clients/${clientId}/dashboard`,
      // <HomeOutlined style={{ color: "#3a5dd3" }} />
      <img src={allclients} alt="all-clients" height={"20px"} width={"20px"} />
    ),

    getItem(
      collapsed ? (
        <Divider className="divider-m0" />
      ) : (
        <Typography.Title
          level={5}
          style={{
            // color: "#395cd2",
            color: "#44546F",
            fontWeight: 600,
            fontSize: "15px",
          }}
        >
          Inventory
        </Typography.Title>
      ),
      "inventory"
    ),
    getItem(
      <Link to={`/inventory/clients/${clientId}/inventory-Dashboard`}>
        Dashboard
      </Link>,
      `/inventory/clients/${clientId}/inventory-Dashboard`,
      // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
      <img
        alt="dashbrd"
        src={dashbrd}
        style={{ height: "19px", width: "15px", marginRight: "6px" }}
      />
    ),
    getItem(
      <Link to={`/inventory/clients/${clientId}/vendorRegistrationReq`}>
        Vendor Registration Request
      </Link>,
      `/inventory/clients/${clientId}/vendorRegistrationReq`,
      // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
      <img
        alt="journals"
        src={journals}
        style={{ height: "19px", width: "15px", marginRight: "6px" }}
      />
    ),

    getItem(
      <Link to={`/inventory/clients/${clientId}/inventoryMaster`}>Master</Link>,
      `/inventory/clients/${clientId}/inventoryMaster`,
      // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
      <img
        alt="journals"
        src={journals}
        style={{ height: "19px", width: "15px", marginRight: "6px" }}
      />
    ),
    getItem(
      <Link to={`/inventory/clients/${clientId}/requisition`}>
        Requisition
      </Link>,
      `/inventory/clients/${clientId}/requisition`,
      // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
      <img
        alt="journals"
        src={journals}
        style={{ height: "19px", width: "15px", marginRight: "6px" }}
      />
    ),
    getItem(
      <Link to={`/inventory/clients/${clientId}/vendor`}>Vendor</Link>,
      `/inventory/clients/${clientId}/vendor`,
      // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
      <img
        alt="journals"
        src={journals}
        style={{ height: "19px", width: "15px", marginRight: "6px" }}
      />
    ),
    getItem(
      <Link to={`/inventory/clients/${clientId}/bids`}>Bids</Link>,
      `/inventory/clients/${clientId}/bids`,
      // <MdOutlineBalance style={{ color: "#3a5dd3" }} />
      <img
        alt="journals"
        src={journals}
        style={{ height: "19px", width: "15px", marginRight: "6px" }}
      />
    ),
  ];
  const selectedMenuItem = (key: any) => {
    if (key === `/billing/clients/${clientId}/sales`) {
      <Link to={key + "/invoices"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/purchase`) {
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/asset`) {
      <Link to={key + "/assetPurchase"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/banking`) {
      <Link to={key + "/bankAccounts"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/ageing`) {
      <Link to={key + "/debtors"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/master`) {
      <Link to={key + "/ledger"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/settings`) {
      <Link to={key + "/companyInfo"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/party`) {
      <Link to={key + "/parties"}></Link>;
      setOpenSiderDrawer(false);
    } else if (key === `/billing/clients/${clientId}/item`) {
      <Link to={key + "/items"}></Link>;
      setOpenSiderDrawer(false);
    } else {
      // navigate(key);
      <Link to={key}></Link>;
      setOpenSiderDrawer(false);
    }
  };
  // useHotkeys(["ctrl+a", "SHIFT+b", "r", "f"], (_, handler: any) => {
  //   switch (handler.keys.join("")) {
  //     case "a":
  //       alert("You pressed ctrl+a!");
  //       break;
  //     case "b":
  //       alert("You pressed shift+b!");
  //       break;
  //     case "r":
  //       alert("You pressed r!");
  //       break;
  //     case "f":
  //       alert("You pressed f!");
  //       break;
  //   }
  // });
  //#region Commented Code
  // React.useEffect(() => {
  //   LogService.getUserLog(LogTypes.Sales, 0, 15).then((res: any) => {
  //     console.log(res, "log response......>>>>>");
  //     if (res !== null || res?.items?.length > 0) {
  //       setLogData(
  //         res?.items?.map((d: any, i: number) => ({
  //           // serialNo: i + 1 + listParams.start,
  //           key: i,
  //           company: d?.company?.name,
  //           date: dayjs(d?.createdBy?.date).format("DD MMM YYYY , hh:mm A"),
  //           description: d?.description,
  //           user: d?.createdBy?.userName,
  //           action: d?.action,
  //         }))
  //       );
  //       // setLoading(false);
  //       // setTotalRecords(res?.totalRecords);
  //     } else {
  //       // messageApi.error(res?.message);
  //     }
  //   });
  // }, []);
  //#endregion
  console.log("Selected Location URL", locationUrl);

  if (loading) {
    console.log("local data FullPageSpinner");
    return <FullPageSpinner />;
  }
  // else if (skeletonLoading) {
  //   return <LayoutSkeleton />;
  // }

  return (
    <>
      <ConfigProvider
        theme={{
          // token: { colorPrimary: "#3a5dd3" },
          token: {
            colorPrimary: themeData?.themeData?.themeColor ?? "#395cd2",
            fontSize: themeData?.themeData?.fontSize ?? 14,
            borderRadius: themeData?.themeData?.borderRadius ?? 6,
            colorLink: themeData?.themeData?.themeColor,
            colorLinkHover: themeData?.themeData?.themeColor,
            // colorLinkActive: themeData?.themeData?.themeColor,
          },
          components: {
            Input: {
              colorBgContainerDisabled: `${themeData?.themeData?.themeColor}40`,
              colorTextDisabled: "dimgrey",
            },
            InputNumber: {
              colorBgContainerDisabled: `${themeData?.themeData?.themeColor}40`,
              colorTextDisabled: "dimgrey",
              colorTextPlaceholder: "dimgrey",
            },
            DatePicker: {
              colorBgContainerDisabled: `${themeData?.themeData?.themeColor}40`,
              colorTextDisabled: "dimgrey",
            },
            Select: {
              colorBgContainerDisabled: `${themeData?.themeData?.themeColor}40`,
              colorTextDisabled: "dimgrey",
            },
            Checkbox: {
              colorTextDisabled: `${themeData?.themeData?.themeColor}40`,
              colorBgContainerDisabled: `${themeData?.themeData?.themeColor}40`,
              colorBorder: `${themeData?.themeData?.themeColor}40`,
            },
          },
          algorithm:
            themeData?.themeData?.darkMode === true
              ? darkAlgorithm
              : defaultAlgorithm,
        }}
        componentSize={themeData?.themeData?.componentSize ?? "middle"}
      >
        <Header
          style={{
            padding: 0,
            // backgroundColor:
            height: "55px",
            // borderBottom: "2px solid #eef2fe",
            // borderBottom: "1px solid #E4E8F0",

            // backgroundColor: "white",
            background: themeData.themeData?.themeColor,
          }}
        >
          <Row justify={"space-between"} style={{ height: "55px" }}>
            <Col
              style={{
                height: "55px",
                width: `${collapsed ? "75px" : "238px"}`,
              }}
            >
              <span>
                <img
                  src={collapsed ? companylogo1 : companylogo}
                  // src={companylogo}
                  width={collapsed ? 42 : 170}
                  height={55}
                  // onClick={() => setCollapsed(!collapsed)}
                  onClick={() =>
                    navigate(`/billing/clients/${clientId}/dashboard`)
                  }
                  style={{
                    margin: "0px 0px 0px 16px",
                    transitionDuration: "0.18s",
                    cursor: "pointer",
                  }}
                  alt="companylogo1"
                />
              </span>
            </Col>
            <Col
              style={{
                height: "55px",
                width: `calc(100% - ${collapsed ? "75px" : "238px"})`,
              }}
            >
              <Row
                justify={"space-between"}
                style={{ height: "100%" }}
                align="middle"
              >
                <Col>
                  <div
                    style={{
                      cursor: "pointer",
                      height: "50px",
                      // textAlign: "center",
                      alignItems: "center",
                    }}
                    onClick={() => {
                      setCollapsed(!collapsed);
                      setOpenSiderDrawer(true);
                    }}
                  >
                    <MenuIcon
                      active={!collapsed}
                      color={themeData?.themeData?.themeColor}
                    />
                  </div>
                </Col>
                <Col
                  style={{
                    height: "50px",
                    alignItems: "center",
                    alignContent: "center",
                  }}
                >
                  <Popover
                    content={<ContentUser />}
                    placement="bottomLeft"
                    trigger="click"
                  >
                    {userData?.profilePhoto?.path ? (
                      <div
                        style={{
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          style={{
                            cursor: "pointer",
                            marginBottom: "4px",
                            marginRight: "15px",
                          }}
                          size={30}
                          src={userData?.profilePhoto?.path}
                        />
                      </div>
                    ) : (
                      <div
                        style={{
                          height: "50px",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <Avatar
                          className="avatar-user"
                          icon={<UserOutlined />}
                          style={{
                            cursor: "pointer",
                            marginRight: "15px",
                          }}
                        />
                      </div>
                    )}
                  </Popover>
                </Col>
              </Row>
            </Col>
          </Row>
        </Header>
        <ClientDataProvider clientId={clientId!}>
          {/* {isAuthenticated() ? ( */}
          <Layout>
            {/* ---------- Sider & Drawer ----------- */}
            {width > 1024 && themeData?.themeData?.silderSize ? (
              <Sider
                trigger={null}
                collapsible
                collapsed={collapsed}
                breakpoint="lg"
                width={240}
                // onCollapse={(x) => {
                //   setCollapsed(x);
                // }}
                style={{
                  background: colorBgContainer,
                  // background: themeData.themeData?.themeColor,
                  position: "fixed",
                  transition: "0.2s",
                  // boxShadow: "2px 1px 5px rgb(81 100 120 / 8%)",
                  boxShadow: "0px 15px 4px 0px #E4E8F0",
                  // boxShadow: "0px 4px 15px 0px #96A1C81C",

                  height: "100vh",
                  // borderRight: "2px solid #eef2fe",
                  borderRight: "1px solid #E4E8F0",
                  textDecoration: "none",
                }}
              >
                <div>
                  <Menu
                    mode="inline"
                    // defaultSelectedKeys={[locationUrl]}
                    selectedKeys={[locationUrl]}
                    defaultSelectedKeys={[locationUrl]}
                    // selectedKeys={[location.pathname]}
                    items={
                      mainCategory === "inventory"
                        ? invItems //"inventory"
                        : items // Default
                    }
                    triggerSubMenuAction={"hover"}
                    onClick={(e: any) => {
                      selectedMenuItem(e.key);
                    }}
                    style={{
                      // top: "6px",
                      position: "relative",
                      overflowY: "auto",
                      height: `calc(100vh - 50px)`,
                      fontFamily: "'Open Sans','sans-serif'",
                      fontSize: "14px",
                      borderRight: "none",
                      background: "#ffffff",
                      // background: themeData.themeData?.themeColor,
                      // border: "1px solid red",
                      // boxShadow: "2px 1px 5px rgb(81 100 120 / 8%)",
                    }}
                  />
                </div>
              </Sider>
            ) : (
              <Drawer
                className="drawerToggle"
                open={openSiderDrawer}
                closeIcon={false}
                onClose={() => setOpenSiderDrawer(false)}
                title={
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: themeData?.themeData?.themeColor,
                      }}
                    >
                      <img
                        src={companylogo}
                        width={120}
                        height={50}
                        // style={{
                        //   margin: "0px 0px 0px 10px",
                        // }}
                        alt="companylogo1"
                      />
                      <div
                        onClick={() => {
                          setOpenSiderDrawer(false);
                        }}
                      >
                        <MenuOutlined
                          style={{
                            fontSize: "20px",
                            // paddingLeft: "0px",
                            marginRight: "3px",
                            color: "white",
                          }}
                        />
                      </div>
                    </div>
                  </>
                }
                // closeIcon={
                //   <div
                //     style={{
                //       display: "flex",
                //       alignItems: "center",
                //       justifyContent: "space-between",
                //     }}
                //   >
                //     <img
                //       src={companylogo}
                //       width={120}
                //       height={50}
                //       style={{
                //         margin: "0px 0px 0px 10px",
                //       }}
                //       alt="companylogo1"
                //     />
                //     <div>
                //       <MenuOutlined
                //         style={{
                //           fontSize: "20px",
                //           paddingLeft: "20px",
                //         }}
                //       />
                //     </div>
                //   </div>
                // }
                placement="left"
                style={{ width: "240px" }}
              >
                <Menu
                  // className="Overide"
                  mode="inline"
                  defaultSelectedKeys={[locationUrl]}
                  items={items}
                  onClick={(e: any) => {
                    selectedMenuItem(e.key);
                  }}
                  style={{
                    // top: "60px",
                    width: "285px",
                    position: "relative",
                    overflowY: "auto",
                    // height: `calc(100vh - 60px)`,
                  }}
                />
              </Drawer>
            )}
            {/* themeData?.themeData?.silderSize !== true */}
            <Layout
              style={{
                marginLeft:
                  width <= 1024 || themeData?.themeData?.silderSize !== true
                    ? "0px"
                    : collapsed !== true
                    ? "240px"
                    : "80px",
                transition: "0.2s",
              }}
            >
              {/* ----------- Header ------------ */}

              {/* ------- Client Details Content ------- */}
              <Content
                style={{
                  background: colorBgContainer,
                  overflowY: "hidden",
                  height: `calc(100vh - 65px)`,
                }}
              >
                {/* <Drawer
                  title="Basic Drawer"  
                  placement={"right"}
                  closable={false}
                  onClose={CloseLogDrawer}
                  open={openLogDrawer}
                >
                  {logData?.map((item: any) => {
                    return (
                      <Timeline
                        items={[
                          {
                            children: (
                              <>
                                <p>{item?.description}</p>
                                <span>{item?.date}</span> By {item?.company}
                              </>
                            ),
                          },
                          {
                            children: (
                              <>
                                <p> {item?.user}</p>
                              </>
                            ),
                          },
                        ]}
                      />
                    );
                  })}
                </Drawer> */}
                {isConnected !== true ? (
                  <Result
                    icon={<WifiOutlined />}
                    title="Network Disconnected"
                    subTitle="Please check your internet connection and try again."
                    extra={
                      <Button
                        type="primary"
                        onClick={() => window.location.reload()}
                      >
                        Retry
                      </Button>
                    }
                  />
                ) : (
                  <>
                    {" "}
                    {matchPath(
                      `/inventory/clients/:clientId/*`,
                      location.pathname
                    ) ? (
                      <InventoryPageRoute />
                    ) : (
                      <PageRoute />
                    )}
                    <FloatButtons
                      setQuickAddProps={setQuickAddProps}
                      clientId={clientId}
                      images={{
                        masters,
                        saleslogo,
                        purchaselogo,
                        AssetImg,
                        journals,
                        bankImg,
                      }}
                    />
                  </>
                )}
              </Content>
            </Layout>
            {/* <ShortcutKeys
              setQuickAddProps={setQuickAddProps}
              quickAddProps={quickAddProps}
              clientId={clientId}
            /> */}
            {/*--------------- QuickAdd Props --------------- */}
            {quickAddProps.type === "addItem" && (
              <AddItems
                open={quickAddProps.open}
                onCancel={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                // id={quickAddProps.id}
                // setTrigger={setTrigger}
              />
            )}
            {quickAddProps.type === "addUnit" && (
              <UnitModel
                open={quickAddProps.open}
                onCancel={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                data={null}
                setTrigger={setUnitTrigger}
              />
            )}
            {/* {quickAddProps.type === "addCategory" && (
              <AddCategoryItemsModel
                open={quickAddProps.open}
                onCancel={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                setTrigger={(x) => !x}
                // id={quickAddProps.id}
              />
            )}
            {quickAddProps.type === "addLocation" && (
              <ItemLocationModel
                open={quickAddProps.open}
                onCancel={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                setTrigger={{}}
                // id={quickAddProps.id}
                // setTrigger={setTrigger}
              />
            )}

              */}

            {quickAddProps.type === "AddLedger" && (
              <AddLedger
                id={""}
                openDrawer={true}
                setOpenDrawer={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                type={quickAddProps.iType}
              />
            )}
            {quickAddProps.type === "AddParty" && (
              <AddLedger
                id={""}
                openDrawer={true}
                setOpenDrawer={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                type={quickAddProps.iType}
                showName="Party"
              />
            )}
            {/* {quickAddProps.type === "AddLedger" && (
              <AddLedger
                id={""}
                openDrawer={true}
                setOpenDrawer={() =>
                  setQuickAddProps({ type: "", open: false })
                }
                showName="Party"
                type={quickAddProps.iType}
              />
            )} */}

            {quickAddProps.type === "AddGroup" && (
              <AddGroup
                open={true}
                editData={""}
                groupData={[]}
                setTrigger={{}}
                onCancel={() =>
                  setQuickAddProps({ type: "", open: false, iType: "" })
                }
                type={quickAddProps.iType}
              />
            )}
            {quickAddProps.type === "AddItems" && (
              <AddItems
                open={true}
                onCancel={() => setQuickAddProps({ type: "", open: false })}
              />
            )}
            {quickAddProps.type === "AddSalesInvoice" && <AddSalesInvoice />}
            {quickAddProps.type === "AdjustBankBalanceModel" && (
              <AdjustBankBalanceModel
                open={true}
                onCancel={() => setQuickAddProps({ type: "", open: false })}
                type={""}
              />
              // <></>
            )}
          </Layout>
          {/* ) : (
             
            // <Layout className="site-layout" />
          )} */}
        </ClientDataProvider>
      </ConfigProvider>
    </>
  );
};

export default AccountsMainLayout;
